import { ChartColumn } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

export const reportsOverviewTour = defineTour({
  id: 'reports.overview',
  version: 1,
  group: 'reports',
  route: '/_authed/_active/s/$storeId/reports/',
  scope: 'store',
  requires: 'reports.read',
  icon: ChartColumn,
  steps: [
    { id: 'tabs', kind: 'explain', target: 'reports.tabs' },
    { id: 'range', kind: 'action', target: 'reports.range' },
    { id: 'kpis', kind: 'explain', target: 'reports.overview.kpis' },
    { id: 'chart', kind: 'explain', target: 'reports.overview.chart', placement: 'top' },
    { id: 'refresh', kind: 'explain', target: 'reports.refresh' },
  ],
  related: ['reports.sales', 'reports.products'],
});

export const reportsSalesTour = defineTour({
  id: 'reports.sales',
  version: 1,
  group: 'reports',
  route: '/_authed/_active/s/$storeId/reports/sales',
  scope: 'store',
  requires: 'reports.read',
  icon: ChartColumn,
  steps: [
    { id: 'interval', kind: 'explain', target: 'reports.sales.interval' },
    { id: 'chart', kind: 'explain', target: 'reports.sales.chart' },
    { id: 'table', kind: 'explain', target: 'reports.sales.table', placement: 'top' },
    { id: 'export', kind: 'explain', target: 'reports.export' },
  ],
  related: ['reports.payments'],
});

export const reportsProductsTour = defineTour({
  id: 'reports.products',
  version: 1,
  group: 'reports',
  route: '/_authed/_active/s/$storeId/reports/products',
  scope: 'store',
  requires: 'reports.read',
  icon: ChartColumn,
  steps: [
    { id: 'table', kind: 'explain', target: 'reports.products.table', placement: 'top' },
    { id: 'range', kind: 'explain', target: 'reports.range' },
    { id: 'export', kind: 'explain', target: 'reports.export' },
  ],
  related: ['reports.inventory'],
});

export const reportsCustomersTour = defineTour({
  id: 'reports.customers',
  version: 1,
  group: 'reports',
  route: '/_authed/_active/s/$storeId/reports/customers',
  scope: 'store',
  requires: 'reports.read',
  icon: ChartColumn,
  steps: [
    { id: 'new-returning', kind: 'explain', target: 'reports.customers.new-returning' },
    { id: 'top', kind: 'explain', target: 'reports.customers.top' },
    { id: 'export', kind: 'explain', target: 'reports.export' },
  ],
  related: ['customers.list'],
});

export const reportsPaymentsTour = defineTour({
  id: 'reports.payments',
  version: 1,
  group: 'reports',
  route: '/_authed/_active/s/$storeId/reports/payments',
  scope: 'store',
  requires: 'reports.read',
  icon: ChartColumn,
  steps: [
    { id: 'tiles', kind: 'explain', target: 'reports.payments.tiles' },
    { id: 'methods', kind: 'explain', target: 'reports.payments.methods', placement: 'top' },
    { id: 'export', kind: 'explain', target: 'reports.export' },
  ],
  related: ['settings.payment-methods'],
});

export const reportsAuctionsTour = defineTour({
  id: 'reports.auctions',
  version: 1,
  group: 'reports',
  route: '/_authed/_active/s/$storeId/reports/auctions',
  scope: 'store',
  requires: 'reports.read',
  icon: ChartColumn,
  steps: [
    { id: 'tiles', kind: 'explain', target: 'reports.auctions.tiles' },
    { id: 'table', kind: 'explain', target: 'reports.auctions.table', placement: 'top' },
    { id: 'range', kind: 'explain', target: 'reports.range' },
  ],
  related: ['auctions.list'],
});

export const reportsInventoryTour = defineTour({
  id: 'reports.inventory',
  version: 1,
  group: 'reports',
  route: '/_authed/_active/s/$storeId/reports/inventory',
  scope: 'store',
  requires: 'reports.read',
  icon: ChartColumn,
  steps: [
    { id: 'tiles', kind: 'explain', target: 'reports.inventory.tiles' },
    { id: 'table', kind: 'explain', target: 'reports.inventory.table', placement: 'top' },
    { id: 'export', kind: 'explain', target: 'reports.export' },
  ],
  related: ['inventory.levels'],
});

export const reportsAnalyticsTour = defineTour({
  id: 'reports.analytics',
  version: 1,
  group: 'reports',
  route: '/_authed/_active/s/$storeId/reports/analytics',
  scope: 'store',
  requires: 'reports.read',
  icon: ChartColumn,
  steps: [
    { id: 'kpis', kind: 'explain', target: 'reports.analytics.kpis' },
    { id: 'counts', kind: 'explain', target: 'reports.analytics.counts', placement: 'top' },
    { id: 'forwarding', kind: 'explain', target: 'reports.analytics.forwarding', placement: 'top' },
    { id: 'log', kind: 'explain', target: 'reports.analytics.log', placement: 'top' },
  ],
  related: ['settings.analytics'],
});
